import { ISearchable } from './Searchable.itf'
/**
 * Auto generated class by generator-sqlite
 * */

/**
* @typedef  PoissonOrigineConstructor
* @type {object}
* @property {Object} idOrigine - the idOrigine value
* @property {string} nom - the nom value
* @property {string} raccourci - the racc value
* @author generator-sqlite
* */
export class PoissonOrigine extends ISearchable {
  /**
   * Creates an instance of PoissonOrigine.
   * @param {PoissonOrigineConstructor} object.idAchats
   * @memberof PoissonOrigine
   * @author generator-sqlite
   * */
  constructor(object) {
    super()
    this.idOrigine = object.idOrigine
    this.nom = object.nom
    this.raccourci = object.racc
  }

  formatToDisplay() {
    this.nom = this.nom.charAt(0).toUpperCase() + this.nom.substring(1).toLowerCase()
    this.lineClassName = 'originLine'
    this.boxClassName = 'originBox'
    this.displayType = 'Origine'
    this.created = true
    return this
  }

  formatToCreate() {
    this.formatToDisplay()
    this.created = false
    this.lineClassName = 'create-originLine'
    return this
  }

  getIdAttribute() {
    return 'idOrigine'
  }

  getNameAttribute() {
    return 'nom'
  }

  getRaccourciAttribute() {
    return 'raccourci'
  }
}
